(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["midtown-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const dialog = document.getElementById('midtown-lightbox');
    if (!dialog || dialog.dataset.init === '1') return;
    dialog.dataset.init = '1';

    const img = dialog.querySelector('.midtown-lightbox__img');
    const counter = dialog.querySelector('.midtown-lightbox__counter');
    const closeBtn = dialog.querySelector('.midtown-lightbox__close');
    const prevBtn = dialog.querySelector('.midtown-lightbox__prev');
    const nextBtn = dialog.querySelector('.midtown-lightbox__next');

    let items = [];
    let idx = 0;

    function show() {
      const a = items[idx];
      if (!a) return;
      img.src = a.href;
      img.alt = a.querySelector('img') ? a.querySelector('img').alt : '';
      counter.textContent = (idx + 1) + ' / ' + items.length;
    }

    function open(list, startIdx) {
      items = list;
      idx = startIdx;
      show();
      dialog.setAttribute('data-open', 'true');
      dialog.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      dialog.removeAttribute('data-open');
      dialog.hidden = true;
      img.src = '';
      document.body.style.overflow = '';
    }

    function next() { idx = (idx + 1) % items.length; show(); }
    function prev() { idx = (idx - 1 + items.length) % items.length; show(); }

    document.addEventListener('click', function (e) {
      const link = e.target.closest('a.midtown-gallery__item');
      if (!link) return;
      e.preventDefault();
      const gallery = link.dataset.gallery;
      const list = Array.from(document.querySelectorAll('a.midtown-gallery__item[data-gallery="' + gallery + '"]'));
      const startIdx = list.indexOf(link);
      open(list, startIdx);
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', prev);
    nextBtn.addEventListener('click', next);

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!dialog.hasAttribute('data-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
